import { configureStore } from '@reduxjs/toolkit';
import sits from './slices/sitsSlice';
import labels from './slices/labelsSlice';
import policies from './slices/policiesSlice';
import nav from './slices/navSlice';
import tenants from './slices/tenantsSlice';
import tenantEntities from './slices/tenantEntitiesSlice';
import dashboardEntity from './slices/dashboardEntitySlice';
import entityMetadata from './slices/entityMetadataSlice';
import tenantCounts from './slices/tenantCountsSlice';
import dashboardPolicies from './slices/dashboardPoliciesSlice';
import tenantPolicies from './slices/tenantPoliciesSlice';
import labelDeployment from './slices/labelDeploymentSlice';
import deploymentTracking from './slices/deploymentTrackingSlice';

export const store = configureStore({
  reducer: {
    sits,
    labels,
    policies,
    nav,
    tenants,
    tenantEntities,
    dashboardEntity,
    entityMetadata,
    tenantCounts,
    dashboardPolicies,
    tenantPolicies,
    labelDeployment,
    deploymentTracking,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
